
export let lang_ar = {
        "id": "الرقم التعريفي",
        "username": "اسم المستخدم",
        "password": "كلمة السر",
        "name": "الأسم",
        "first_name": "الأسم الاول",
        "second_name": "الأسم الثاني",
        "middle_name": "الاسم الأوسط",
        "last_name": "الأسم الاخير",
        "start_date": "تاريخ البدء",
        "end_date": "تاريخ الانتهاء",
        "start_time": "وقت البدء",
        "end_time": "وقت الإنتهاء",
        "branches": "الأفرع",
        "service": "الخدمة",
        "services": "الخدمات",
        "packages": "الصفقات",
        "package": "صفقة",
        "price_list":"قائمة الاسعار",
        "default_price_list": "قائمة الاسعار الافتراضية",
        "prices": "الاسعار",
        "price": "السعر",
        "total": "المجموع",
        "gender": "الجنس",
        "birthday": "تاريخ الميلاد",
        "birth_date": "تاريخ الميلاد",
        "branch": "الفرع",
        "profile": "الملف الشخصي",
        "logout": "تسجيل الخروج",
        "signin": "تسجيل الدخول",
        "signup": "تسجيل الإشتراك",
        "search": "بحث",
        "clients": "العملاء",
        "client": "العميل",
        "memberships": "الاعضاء المشتركين",
        "membership": "عضوية الإشتراك",
        "employee": "الموطف",
        "employees": "الموطفين",
        "actions": "الأجراءات",
        "action": "الأجراء",
        "mobile": "رقم الهاتف",
        "telephone": "هاتف",
        "social_id": "الهوية الاجتماعية",
        "nationality": "الجنسية",
        "add": "اضافة",
        "remove": "إزالة",
        "add_all": "اضافة الكل",
        "remove_all": "إزالة الكل",
        "delete": "حذف",
        "save": "حفظ",
        "cancel": "إلغاء",
        "close": "إغلاق",
        "paid": "المدفوع",
        "balance": "المتبقي",
        "male": "ذكر",
        "female": "انثى",
        "none": "لا قيمة",
        "change_lang": "التغير اللغة إلى الإنجليزية",
        "yes": "نعم",
        "no": "لا",
        "account": "الحساب",
        "status": "الحاله",
        "notes": "الملاحظات",
        "duration": "المده",
        "duration_days": "المده (الايام)",
        "date_created": "تاريخ الإنشاء",
        "date_modified": "تاريخ التعديل",
        "approve": "الموافق",
        "reject": "الرفض",
        "sessions": "الحصص",
        "address": "العنوان",
        "coordinates": "الإحداثيات",
        "timezone": "المنطقة زمنية",
        "tax": "الضريبة",
        "discount": "الخصم",
        "amount": "المبلغ",
        "passport_number": "دقم جواز السفر",
        "email": "البريد الإلكتروني",
        "is_active": "فعال",
        "Disactive": "غير فعال",
        "country": "دولة",
        "currency_symbol": "رمز العملة",
        "emergency_contact_name": "اسم جهة اتصال الطوارئ",
        "emergency_contact_telephone": "هاتف الاتصال في حالات الطوارئ",
        "request_no": "رقم الطلب",
        "feedback_by": "الرد بواسظة",
        "feedback_date": "تاريخ الرد",
        "other": "أخرى",
        "cash": "نقدي",
        "debit": "بطاقة ائتمان",
        "credit": "بطاقة ائتمان ٢",
        "pay": "دفع",
        "refund": "إعادة مال",
        "back": "الرجوع",
        "for": "لأجل",
        "males": "الرجال",
        "females": "النساء",
        "offers": "العروض",
        "type": "النوع",
        "description": "الوصف",
        "equipment": "المعدات",
        "qty": "الكمية",
        "increase": "زيادة",
        "decrease": "تخفيض",
        "received": "تم الأستلام",
        "delivered": "تم التوصيل",
        "total_qty": "إجمالي الكمية",
        "available_qty": "الكمية المتوفرة",
        "rented_qty": "الكمية المؤجرة",
        "area":"منطقة",
        "city":"مدينة",
        "locations": "المواقع",
        "location": "الموقع",
        "address_line_one" : "العنوان الأول",
        "address_line_two" : "العنوان الثاني",
        "address_line_three" : "العنوان الثالث",
        "map_location": "خريطة الموقع",
        "staff": "الموطفين",
        "change_photo": "تغير الصورة",
        "role": "المنصب",
        "permission_group": "مجموعة الصلاحية",
        "change_password": "تغير كلمة السر",
        "assigned_to": "مخصص إلى",
        "all_locations": "جميع المواقع",
        "details": "التفاصيل",
        "information": "معلومات",
        "setting": "الإعداد",
        "available_at": "متوفر عند",
        "show": "مشاهده",
        "cancellation": "الإلغاء",
        "freezes": "الإيقافات",
        "payments": "المدفوعات",
        "cancellation_date": "تاريخ الإلغاء",
        "title": "العنوان",
        "date": "التايخ",
        "expenses": "النفقات",
        "expense": "النفقة",
        "ex_number": "رقم النفقة",
        "ex_date": "تاريخ النفقة",
        "add_expense": "إضافة نفقة",
        "edit_expense": "تحرير النفقة",
        "view_expense": "عرض النفقة",
        "expense_category": "فئة النفقة",
        "add_expense_category": "أضافة فئة النفقات",
        "edit_expense_category": "تحرير فئة النفقات",
        "open": "فتح",
        "payment_information": "معلومات الدفع",
        "expense_information": "معلومات النفقة",
        "expense_attachment": "مرفق النفقة",
        "attachment": "المرفق",
        "add_attachment": "إضافة مرفق",
        "edit_attachment": "تحرير المرفق",
        "cost": "التكلفة",
        "remove_file": "إزالة الملف",
        "paid_by": "دفع عن طريق",
        "add_payment_method": "إضافة طريقة دفع",
        "edit_payment_method": "تحرير طريقة دفع",
        "commission_type" : "نوع العمولة",
        "commission" : "العمولة",
        "invoices" : "الفاوتير",
        "finance" : "المالية",
        "bank_transfers" : "التحويلات المصرفية",
        "add_bank_transfer" : "إضافة تحويل مصرفي",
        "edit_bank_transfer" : "تحرير التحويل المصرفي",
        "view_bank_transfer" : "عرض التحويل المصرفي",
        "bank_account" : "الحساب المصرفي",
        "add_bank_account" : "إضافة حساب مصرفي",
        "edit_bank_account" : "تحرير حساب مصرفي",
        "view_bank_account" : "عرض الحساب المصرفي",
        "bank_transactions" : "معاملات بنكية",
        "current_balance" : "الرصيد الحالي",
        "sender" : "المرسل",
        "total_price": "السعر الكلي",
        "access_permissions": "أذونات الوصول",
        "reference": "المرجع",
        "payment_date": "تاريخ الدفع",
        "payment_type": "نوع الدفع",
        "payment_method": "طريقة الدفع",
        "add_payment": "إضافة دفعة جديدة",
        "add_refund": "إعادة مال",
        "number": "الرقم",
        "rents": "الإيجارات",
        "add_rent": "إضافة إيجار جديد",
        "edit_rent": "تحرير الإيجار",
        "activate_rent" : "تنشيط الإيجار",
        "cancel_rent" : "إلغاء الإيجار",
        "transfer_number" : "رقم التحويل",
        "recipient" : "المستلم",
        "cash_transfer" : "تحويل نقدي",
        "new_transfer" : "تحويل جديد",
        "sent_transfer" : "النقل المرسل",
        "received_transfer" : "التحويل المستلم",
        "transfer_form" : "نموذج التحويل",
        "cancel_transfer" : "إلغاء النقل",
        "confirm" : "تأكيد",
        "cash_log" : "سجل النقدية",
        "sender_type" : "نوع المرسل",
        "recipient_type" : "نوع المستلم",
        "sender_current_balance" : "الرصيد الحالي للمرسل",
        "recipient_current_balance" : "الرصيد الحالي للمستلم",
        "pending_balance" : "الرصيد المعلق",
        "free_balance" : "رصيد مجاني",
        "available_balance" : "الرصيد المتاح",
        "target_staff" : "الموظفين المستهدفين",
        "add_cash_deposit" : "أضف وديعة نقدية",
        "add_funds" : "إضافة الأموال",
        "add_withdraw" : "إضافة سحب",
        "received_as" : "تم الاستلام كـ",
        "method" : "طريقة",
        "total_amount": "المبلغ الإجمالي",
        "from_cash_log": "من سجل النقدية",
        "bank_transfer_information": "معلومات التحويل المصرفي",
        "cheque": "الشيك",
        "bank_transfer" : "تحويل مصرفي",
        "paid_from" : "مدفوع من",
        "personal_money" : "المال الشخصي",
        "reimbursements" : "التسديدات",
        "remaining" : "المتبقي",
        "view_reimbursement" : "عرض السداد",
        "attachments" : "المرفقات",
        "add_class" : "إضافة فصل",
        "edit_class" : "تحرير الفصل",
        "classes" : "فصول",
        "schedule" : "جدول",
        "limit" : "الحد",
        "duration_minutes" : "المدة (دقائق)",
        "saturday" : "السبت",
        "sunday" : "الأحد",
        "monday" : "الإثنين",
        "tuesday" : "الثلاثاء",
        "wednesday" : "الأربعاء",
        "thursday" : "الخميس",
        "friday" : "الجمعة",
        "from_date" : "من التاريخ",
        "to_date" : "حتى تاريخ",
        "add_time" : "إضافة وقت",
        "days" : "أيام",
        "vip_capacity" : "سعة كبار الشخصيات",
        "capacity" : "سعة",
        "room" : "غرفة",
        "edit_class_session" : "تحرير جلسة الفصل",
        "add_class_session" : "إضافة جلسة الفصل",
        "class_sessions" : "جلسات الفصل",
        "is_locked" : "مغلق",
        "registered_number" : "الرقم المسجل",
        "rooms": "غرف",
        "add_room" : "أضف غرفة",
        "edit_room" : "تحرير غرفة",
        "room_form" : "نموذج الغرفة",
        "edit_attendee" : "تحرير الحضور",
        "add_attendee" : "إضافة حاضر",
        "attendee_form" : "نموذج الحضور",
        "attendee": "الحضور",
        "attendees": "الحاضرين",
        "is_present": "حاضر",
        "is_cancelled": "تم إلغاء",
        "added_by": "أضيف بواسطة",
        "group_by_date": "تجميع حسب التاريخ",
        "class_session" : "جلسة الفصل",
        "add_class_sessions" : "إضافة جلسة الفصل",
        "edit_class_sessions" : "تحرير جلسة الفصل",
        "add_screen": "إضافة شاشة",
        "edit_screen": "تحرير الشاشة",
        "screen": "شاشة",
        "screens": "شاشات",
        "workout_screens": "شاشات التمارين",
        "workout": "تمرين",
        "add_workout": "أضف تمرين",
        "edit_workout": "تحرير تمرين",
        "workout_form": "نموذج تمرين",
        "content": "المحتوى",
        "header": "العنوان",
        "display_screen": "شاشة عرض",
        "next": "التالى",
        "duplicate_workout": "كرر التمرين",
        "workouts": "التمارين",
        "whole_day": "طوال اليوم",
        "view_for": "عرض ل",
        "add_location": "إضافة موقع جديد",
        "edit_location": "تعديل بيانات موقع",
        "preferred_training_time": "وقت التدريب المفضل",
        "invoice_date": "تاريخ الفاتورة",
        "dashboard": "لوحة الإدارة",
        "view": "عرض",
        "confirm_password": "تأكيد كلمة المرور",
        "company_name": "اسم الشركة",
        "business_name": "الاسم التجاري",
        "personal_info": "المعلومات الشخصية",
        "entity_info": "معلومات الكيان.",
        "user_info": "معلومات الحساب",
        "confirm_&_submit": "تأكيد وإرسال",
        "already_have_an_account?_sign_in": "هل لديك حساب؟ تسجيل الدخول",
        "submit": "إرسال",
        "personal_information": "المعلومات الشخصية",
        "entity_information": "معلومات الكيان",
        "user_information": "معلومات الحساب",
        "membership_info": "بيانات المشترك",
        "freezed": "متوقف",
        "transfer": "تحويل",
        "upgrade_duration": "تطوير المدة",
        "alert": "تنبيه",
        "ok": "موافق",
        "change_invoice_date": "تغيير تاريخ الفاتورة",
        "sub_directory": "الدليل الفرعي",
        "view_transfer_from": "عرض التحويل من",
        "view_transfer_to": "عرض نقل إلى",
        "create": "إنشاء",
        "import_data": "استيراد البيانات",
        "enter_entity": "أدخل الكيان",
        "model_&_file": "النموذج والملف",
        "entity_pk": "معرف الكيان",
        "models": "النماذج",
        "model": "النمودج",
        "view_info": "عرض المعلومات",
        "write_entity_sub_director_to_confirm_the_process": "اكتب مدير الكيان الفرعي لتأكيد العملية",
        "file": "الملف",

        "empty_data_source_message": "لا توحد سجلات للعرض",
        "table.delete_text": "هل أنت متأكد أنك تريد حذف هذة البيانات ؟",

};
